// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__6jQeR","label":"LabeledBox_label__3E42-"};